import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import { parseISO, format } from "date-fns";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import MarkdownWrapper from "../MarkdownWrapper";

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(2),
	},
	content: {
		minWidth: 400,
		minHeight: 200,
        display: "flex",
        flexDirection: "column",
	},
    loadingContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        flex: 1,
        minHeight: 200
    },
    loadingText: {
        marginTop: theme.spacing(2),
        color: "#35af9a"
    },
    markdownSection: {
        "& h1, & h2, & h3": {
            color: "#35af9a",
            fontWeight: 600,
            fontSize: "16px",
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
            fontFamily: '"Inter", "Poppins", sans-serif',
        },
        "& p": {
            fontSize: "14px",
            color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
            lineHeight: 1.6,
            marginBottom: theme.spacing(1),
        },
        "& ul, & ol": {
            paddingLeft: theme.spacing(3),
            marginBottom: theme.spacing(1.5),
        },
        "& li": {
            fontSize: "14px",
            color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
            marginBottom: theme.spacing(0.5),
        }
    }
}));

const AiAnalysisModal = ({ open, onClose, ticketId }) => {
	const classes = useStyles();
	const [loading, setLoading] = useState(false);
	const [analysisResult, setAnalysisResult] = useState("");

	useEffect(() => {
		if (open && ticketId) {
			fetchAnalysis();
		}
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open, ticketId]);

    const fetchAnalysis = async () => {
        setLoading(true);
        setAnalysisResult("");
        try {
            const { data } = await api.post(`/tickets/${ticketId}/ai-analysis`);
            setAnalysisResult(data.data);
        } catch (err) {
            toastError(err);
            onClose();
        } finally {
            setLoading(false);
        }
    }

	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="ai-analysis-dialog-title"
			maxWidth="md"
			fullWidth
		>
			<DialogTitle id="ai-analysis-dialog-title">
                <Box style={{ display: "flex", alignItems: "center" }}>
                    <SmartToyIcon style={{ marginRight: 8, color: "#35af9a" }} />
				    Analisando Atendimento com IA
                </Box>
			</DialogTitle>
			<DialogContent dividers className={classes.content}>
				{loading ? (
					<div className={classes.loadingContainer}>
						<CircularProgress size={50} style={{ color: "#35af9a"}} />
                        <Typography className={classes.loadingText}>Processando a conversa... Por favor, aguarde.</Typography>
					</div>
				) : (
                    analysisResult ? (
                        <Box className={classes.markdownSection}>
                            <MarkdownWrapper full>{analysisResult}</MarkdownWrapper>
                        </Box>
                    ) : (
                        <Typography>Nenhum resultado obtido.</Typography>
                    )
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color="primary" disabled={loading} variant="outlined">
					Fechar
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AiAnalysisModal;
